import React from "react";
import { useTranslation } from "react-i18next";
import { PhoneIcon, ClockIcon, EnvelopeIcon } from "@heroicons/react/24/solid";
import { motion } from "framer-motion";
import "./ContactCards.css";

const ContactCards = () => {
  const { t } = useTranslation();

  const cards = [
    {
      type: "phone",
      icon: <PhoneIcon className="icon" />,
      title: t("contactCards.phone.title"),
      href: "tel:+201221257661",
      content: (
        <>
          <span>{t("contactCards.phone.call")}</span>
          <span>00201221257661</span>
        </>
      ),
    },
    {
      type: "hours",
      icon: <ClockIcon className="icon" />,
      title: t("contactCards.hours.title"),
      content: <>{t("contactCards.hours.schedule")}</>,
    },
    {
      type: "email",
      icon: <EnvelopeIcon className="icon" />,
      title: t("contactCards.email.title"),
      href: "mailto:draliobida@gmail.com",
      content: <>draliobida@gmail.com</>,
    },
  ];

  return (
    <div className="contact-cards-container">
      {cards.map((card, index) => {
        const CardWrapper = card.href ? "a" : "div";
        return (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 100, scale: 0.95 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{
              duration: 0.6,
              ease: "easeOut",
              delay: index * 0.2,
            }}
          >
            <CardWrapper
              className="contact-card"
              href={card.href}
              target={card.type === "email" ? "_blank" : undefined}
              rel={card.type === "email" ? "noopener noreferrer" : undefined}
            >
              <div className="card-inner">
                {card.icon}
                <div className="text-content">
                  <h3 className="card-title">{card.title}</h3>
                  <p className="card-content">{card.content}</p>
                </div>
              </div>
            </CardWrapper>
          </motion.div>
        );
      })}
    </div>
  );
};

export default ContactCards;
